import type { UserDto } from '@api/WhisApi/generated/model/userDto';
import { ControllerRenderProps, FieldPath } from 'react-hook-form';
import type { UserFormValues } from './userForm.types';

export const buildUserFormDefaults = (
  user?: UserDto | null,
  lockedCountry?: UserDto['country'],
): UserFormValues => ({
  firstName: user?.firstName ?? '',
  lastName: user?.lastName ?? '',
  email: user?.email ?? '',
  organization: user?.organization ?? '',
  countryCode: user?.country?.code ?? lockedCountry?.code ?? '',
});

export const getTextValue = (
  field: ControllerRenderProps<UserFormValues, FieldPath<UserFormValues>>,
): string => (typeof field.value === 'string' ? field.value : '');
